import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface UserDataState {
  data: any | null;
}

const initialState: UserDataState = {
  data: null,
};

const userDataSlice = createSlice({
  name: "userData",
  initialState,
  reducers: {
    setSettings: (state, action: PayloadAction<any>) => {
      state.data = action.payload;
    },
    clearSettings: (state) => {
      state.data = null;
    },
  },
});

export const { setSettings, clearSettings } = userDataSlice.actions;
export default userDataSlice.reducer;
